import type { StatefulDiaryT } from "@/types/database/diaries";
import type { EntryViewT } from "@/types/database/entries";

export function flattenEntriesView(entries: EntryViewT[]) {
    return entries?.flatMap((entry) => entry.entry_values);
}

export function combineTrackerEntries(diary: StatefulDiaryT): EntryViewT[] {
    if (!diary?.trackers_view?.length) return [];

    const entries = diary.trackers_view
        .filter((tracker) => tracker.entries_view?.length > 0)
        .flatMap((tracker) => tracker.entries_view);
    return entries;
}

export function findLatestEntry(diary: StatefulDiaryT): EntryViewT | null {
    try {
        const entries = combineTrackerEntries(diary);
        if (!entries.length) return null;

        return entries.reduce((latest, entry) => {
            if (!latest) return entry;
            return entry.calculated_entry_time > latest.calculated_entry_time ? entry : latest;
        });
    } catch (e) {
        console.error(e);
        return null;
    }
}

export const getEntryValues = (diary: StatefulDiaryT) => {
    const entries = combineTrackerEntries(diary);
    const entryValues = flattenEntriesView(entries);
    return entryValues;
};
